import { useEffect, useState } from "react";
import {
  META,
  GOOGLE,
  TIKTOK,
  LINKEDIN,
  VIDEO_GENERATION_STATUS,
  IMAGE_GENERATION_STATUS,
  CAMPAIGN_GENERATION_STATUS,
} from "../../utils/constants";
import Box from "@mui/material/Box";
import { useDispatchApp } from "../../lib/redux";
import { startListenerAdsPlatformsBanners } from "../../actions/adsCampaigns";
import {
  ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER,
  ALERT_IMAGE_PROVIDER_STATUS_BANNER,
  ALERT_PLATFORM_STATUS_BANNER,
  ALERT_VIDEO_PROVIDER_STATUS_BANNER,
} from "../../i18n/keysTranslations";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { t } from "i18next";

const PLATFORM_STATUS_BANNER_MESSAGE_BY_PLATFORM = {
  [IMAGE_GENERATION_STATUS]: ALERT_IMAGE_PROVIDER_STATUS_BANNER,
  [VIDEO_GENERATION_STATUS]: ALERT_VIDEO_PROVIDER_STATUS_BANNER,
  [CAMPAIGN_GENERATION_STATUS]: ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER,
};

const toTitleCasePlatformLabel = (platform) =>
  platform.charAt(0).toUpperCase() + platform.slice(1);

const getPlatformStatusBannerText = (platform) => {
  const i18nKey =
    PLATFORM_STATUS_BANNER_MESSAGE_BY_PLATFORM[platform] ??
    ALERT_PLATFORM_STATUS_BANNER;

  if (i18nKey === ALERT_PLATFORM_STATUS_BANNER) {
    return t(i18nKey, { platform: toTitleCasePlatformLabel(platform) });
  }

  return t(i18nKey);
};

export const PlatformStatusBanner = () => {
  const [status, setStatus] = useState({
    [META]: true,
    [GOOGLE]: true,
    [TIKTOK]: true,
    [LINKEDIN]: true,
    [VIDEO_GENERATION_STATUS]: true,
    [IMAGE_GENERATION_STATUS]: true,
    [CAMPAIGN_GENERATION_STATUS]: true,
  });
  const [closedAlerts, setClosedAlerts] = useState({});

  const dispatch = useDispatchApp();

  useEffect(() => {
    dispatch(
      startListenerAdsPlatformsBanners({
        onUpdatedDataCallback: (data) => {
          setStatus(data);
          // Reset closed alerts when status changes
          setClosedAlerts({});
        },
      })
    );
    // eslint-disable-next-line
  }, []);

  const handleCloseAlert = (platform) => {
    setClosedAlerts((prev) => ({
      ...prev,
      [platform]: true,
    }));
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        left: 20,
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {Object.entries(status)
        .filter(([, isOnline]) => !isOnline)
        .filter(([platform]) => !closedAlerts[platform])
        .map(([platform]) => (
          <Box
            key={platform}
            sx={{
              backgroundColor: "rgba(255, 243, 205, 0.95)",
              border: "1px solid rgba(255, 229, 143, 0.8)",
              color: "#664d03",
              borderRadius: 1,
              boxShadow: 2,
              minWidth: "300px",
              maxWidth: "450px",
              py: 1,
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <WarningAmberIcon fontSize="20px" />
              <Box sx={{ fontSize: "12px", fontWeight: "medium" }}>
                {getPlatformStatusBannerText(platform)}
              </Box>
            </Box>
            <IconButton
              size="small"
              onClick={() => handleCloseAlert(platform)}
              sx={{ color: "#664d03" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
    </Box>
  );
};
